/* eslint-disable jsx-a11y/media-has-caption */
import * as React from 'react'

type Track = {
  src: string
  kind: 'captions' | 'chapters' | 'descriptions' | 'metadeta' | 'subtitles'
  srcLang: string
  label: string
}

type VideoProps = {
  width?: number
  height?: number
  src: string
  type: string
  controls: boolean
  autoPlay: boolean
  track: Track[]
  onPlay?: () => null
}
export const Video: React.SFC<VideoProps> = props => (
  <video
    width={props.width}
    height={props.height}
    controls={props.controls}
    autoPlay={props.autoPlay}
    onPlay={props.onPlay}
  >
    <source src={props.src} type={props.type} />
    {props.track && props.track.map(trackData => <track {...trackData} />)}
  </video>
)
